import { Col, Row } from "antd";
import { Dialog } from "@src/appV2/redesign/components/Dialog";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { BerlinThemeProvider } from "@src/appV2/redesign/theme/ThemeProvider";
import { ModalStatus, type UseModalState } from "@src/lib/ui-react";
import { Notifications } from "src/containers/myAccount/Notification";
import { ListHeaderItem } from "src/containers/myAccount/styles";
import { TeamMemberActions } from "src/containers/teamMembers/teamMemberReducer";
import { IUser } from "src/modules/myAccount/types";
import { Dispatch, memo, useMemo } from "react";

interface Props {
  member?: IUser;
  visibility: boolean;
  dispatch: Dispatch<TeamMemberActions>;
}

function TeamMemberNotificationImpl(props: Props) {
  const { member, visibility, dispatch } = props;

  const handleClose = () => {
    dispatch({
      type: "SET_NOTIFICATIONS_MODAL_VISIBILITY",
      notificationModal: false,
    });
    dispatch({ type: "SET_MODAL_MEMBER", member: undefined });
  };

  const handleDone = () => {
    dispatch({
      type: "SET_NOTIFICATIONS_MODAL_VISIBILITY",
      notificationModal: false,
    });
  };

  const modalState: UseModalState = useMemo(
    () => ({
      modalStatus: visibility ? ModalStatus.OPEN : ModalStatus.CLOSED,
      modalIsOpen: visibility,
      modalIsClosed: !visibility,
      setModalStatus: () => undefined,
      openModal: () => undefined,
      closeModal: () => undefined,
    }),
    [visibility]
  );

  if (!member) {
    return null;
  }

  return (
    <BerlinThemeProvider>
      <Dialog
        modalState={modalState}
        title="Notification Preferences"
        width={800}
        onClose={handleClose}
        footerContent={
          <DialogFooter
            primaryAction={{
              label: "Done",
              onClick: handleDone,
            }}
          />
        }
      >
        <Row align="middle" style={{ marginBottom: 8 }}>
          <Col span={15} />
          <ListHeaderItem span={3} style={{ fontSize: 16 }}>
            Email
          </ListHeaderItem>
          <ListHeaderItem span={3} style={{ fontSize: 16 }}>
            SMS
          </ListHeaderItem>
          <ListHeaderItem span={3} style={{ fontSize: 16 }}>
            Web Push
          </ListHeaderItem>
        </Row>
        <Notifications member={member} />
      </Dialog>
    </BerlinThemeProvider>
  );
}

export const TeamMemberNotification = memo(TeamMemberNotificationImpl);
